import { graphQLClient } from '@/client/services/api/clients/graphqlClient';
import { adminMessagingDetailQuery } from './queries/adminMessagingDetailQuery';
import { adminMessagingListQuery } from './queries/adminMessagingListQuery';
import { activeAnnouncementsQuery } from './queries/activeAnnouncementsQuery';
import { createAnnouncementMutation } from './mutations/createAnnouncementMutation';
import { deleteAnnouncementMutation } from './mutations/deleteAnnouncementMutation';
import { updateAnnouncementMutation } from './mutations/updateAnnouncementMutation';

export interface AppAnnouncementSegmentInput {
  type: string;
  id: string;
  name: string;
}

export interface AppAnnouncementTranslationInput {
  languageCode: string;
  content: string;
}

export interface AppAnnouncementCreateInput {
  title: string;
  content: string;
  routes: string[];
  published: boolean;
  segmentation?: AppAnnouncementSegmentInput[];
  translations: AppAnnouncementTranslationInput[];
}

export interface AppAnnouncementUpdateInput {
  title?: string;
  content?: string;
  routes?: string[];
  published?: boolean;
  segmentation?: AppAnnouncementSegmentInput[];
  translations?: AppAnnouncementTranslationInput[];
}

const listAnnouncements = async (page = 0, perPage = 20, published?: boolean) => {
  const result = await graphQLClient.request(adminMessagingListQuery, { page, perPage, published });
  return result.appAnnouncements;
};

const getAnnouncement = async (id: string) => {
  const result = await graphQLClient.request(adminMessagingDetailQuery, { id });
  return result.appAnnouncement;
};

const getActiveAnnouncements = async (route: string) => {
  const result = await graphQLClient.request(activeAnnouncementsQuery, { route });
  return result.activeAppAnnouncements;
};

const createAnnouncement = async (input: AppAnnouncementCreateInput) => {
  const result = await graphQLClient.request(createAnnouncementMutation, { input });
  return result.createAppAnnouncement;
};

const updateAnnouncement = async (id: string, input: AppAnnouncementUpdateInput) => {
  const result = await graphQLClient.request(updateAnnouncementMutation, { id, input });
  return result.updateAppAnnouncement;
};

const deleteAnnouncement = async (id: string) => {
  const result = await graphQLClient.request(deleteAnnouncementMutation, { id });
  return result.deleteAppAnnouncement;
};

export const AdminMessagingService = {
  listAnnouncements,
  getAnnouncement,
  getActiveAnnouncements,
  createAnnouncement,
  updateAnnouncement,
  deleteAnnouncement,
};
